module.exports = __webpack_public_path__ + "static/media/S1P1_inherited-risk.6e6a8a03.mp3";